import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    data: [],
}

const privacyPolicySlice = createSlice({
    name: 'privacyPolicy',
    initialState,
    reducers: {
        loaderListener: (state, action) => {
            state.loading = action.payload.loading;
        },
        successPrivacyPolicyReducer: (state, action) => {
            state.data = action.payload.data;
        },
        failedPrivacyPolicyReducer: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
});

export const { successPrivacyPolicyReducer, failedPrivacyPolicyReducer, loaderListener } = privacyPolicySlice.actions;

export default privacyPolicySlice.reducer;